// This file contains all the interfaces for the filters, to be used for the different service
export class ITrackerFilter {
    retailer_id: number;
}
export class IUserFilter {
    first_name: string;
    last_name: string;
    is_admin: boolean;
}




// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/entities/filters.entity.ts